export default function toProperName(name: string) {
  switch (name) {
    case 'freshbooks':
      return 'FreshBooks';
    case 'quickbooks':
      return 'QuickBooks';
    case 'stripe':
      return 'Stripe';
    case 'paymentspring':
      return 'PaymentSpring';
    default:
      return name.slice(0, 1).toUpperCase() + name.slice(1).toLowerCase();
  }
}
